import { render } from "./InicioSesionForm.vue?vue&type=template&id=0498506a&scoped=true"
import script from "./InicioSesionForm.vue?vue&type=script&lang=js"
export * from "./InicioSesionForm.vue?vue&type=script&lang=js"

import "./InicioSesionForm.vue?vue&type=style&index=0&id=0498506a&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0498506a"]])

export default __exports__